import { UntypedFormArray, UntypedFormGroup } from '@angular/forms';

import {
  ActivityDefinitionDto,
  ComponentDto,
  GuidelineActionPriority,
  GuidelineActionSignificance,
  GuidelineComponentType,
  SelectionBehavior,
  Attachment,
} from '@treetop/shared/model';

import { registerTranslationControls } from './CriterionUtil';

export function setGuidelineActionForMedication(
  data: {
    originalDefinition: ComponentDto;
    overwrittenDefinition: ComponentDto;
  },
  action: UntypedFormGroup,
  significance: GuidelineActionSignificance,
  priority: GuidelineActionPriority,
  attachments: Attachment[],
): void {
  const originalActivityDefinition = data.originalDefinition as ActivityDefinitionDto;
  const id = crypto.randomUUID();

  // Quick fix, we would need to review handling of alternativeTranslations/regionalTranslations
  originalActivityDefinition.regionalTranslations = [];
  registerTranslationControls(data.overwrittenDefinition.alternativeTranslations, action);
  (action.get('alternativeTranslations') as UntypedFormArray)?.setValue(data.overwrittenDefinition.alternativeTranslations);
  action.patchValue({
    id: id,
    uniqueId: id,
    //This converts from activityType to guidelineComponentType
    componentType: GuidelineComponentType.Action,
    activityDefinitionCode: originalActivityDefinition?.code,
    activityDefinitionVersion: originalActivityDefinition?.version,
    activityDefinition: originalActivityDefinition,
    significance: significance,
    priority: priority,
    argument: null,
    selectionBehaviorForChildren: SelectionBehavior.And,
    selectionBehaviorForSiblings: SelectionBehavior.And,
    isFollowUp: false,
    parentId: null,
    medicationGroupId: null,
    title: data.overwrittenDefinition.title,
    description: data.overwrittenDefinition.description,
    outgoingActionRelationships: [],
    children: [],
    medicationRequests: [],
    preferredOptionOrder: null,
    attachments: attachments,
    codeableConceptValues: data.overwrittenDefinition.selectedCodeableConceptValues,
  });
}
